import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import { SearchIcon, X } from 'lucide-react';
import React from 'react'
import { useStyles } from './admin/AdminPayoutsPage';

type SearchFieldProps = {
    showSearch: boolean,
    setShowSearch: React.Dispatch<React.SetStateAction<boolean>>
    input: string,
    setInput: (val: string) => void
    clearSearch: () => void,
    applyFilters: () => void,
}


export default function SearchField({ showSearch, setShowSearch, input, setInput, clearSearch, applyFilters }: SearchFieldProps) {
    const classes = useStyles();

    if (!showSearch) return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>Username</span>

            <IconButton
                size="small"
                onClick={() => setShowSearch(true)}
            >
                <SearchIcon fontSize="small" size={20} color="white" />
            </IconButton>
        </div>
    )
    return (
        <TextField
            autoFocus
            size="small"
            variant="outlined"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") applyFilters();
            }}
            InputProps={{
                classes: {
                    input: classes.tableHeaderCell,
                    notchedOutline: classes.noBorder,
                },
                startAdornment: (
                    <InputAdornment position="start" onClick={applyFilters}>
                        <SearchIcon fontSize="small" size={20} className={classes.searchInput} />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            size="small"
                            onClick={clearSearch}
                        >
                            <X fontSize="small" color="white" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    )
}
